import router from './router'
import { getCache } from '@/utils/cache'
import { Toast } from 'vant'
// 修改：引入 setScopedToken 以便兜底写入
import { getScopedToken, setScopedToken } from '@/utils/authScope'

router.beforeEach((to, from, next) => {
  // 若目标路由需要鉴权（建议统一给需要登录的路由添加 meta: { requireAuth: true, loginPage: '...' }）
  const needAuth = to.meta && to.meta.requireAuth
  console.log('Navigating to:', to.path, 'Requires Auth:', needAuth);
  if (needAuth) {
    let token = getScopedToken(to)
    console.log('Scoped Token:', token);

    // 兜底：刚从系统登录页跳转过来，但还未按 scope 写入 token 的场景
    if (!token) {
      const legacy = getCache('token') || getCache('Authorization')
      if (legacy) {
        // 仅当“路由所属系统”与缓存 system_type 一致时补写，避免跨系统串登录
        const systemType = getCache('system_type') // 1林业 2物流 3采购
        const userType = getCache('user_type')     // 3/4 视为投标端，其它视为招标端
        const path = to.path || ''
        const routeSystemType =
          path.startsWith('/logisticsTender') ? 2 :
          path.startsWith('/auctionItem') ? 1 :
          (path.startsWith('/procurement') || path.startsWith('/tendering')) ? 3 : null

        if (routeSystemType && systemType === routeSystemType) {
          const systemKey = routeSystemType === 1 ? 'forestry' : routeSystemType === 2 ? 'logistics' : 'procurement'
          const terminalKey = (userType === 3 || userType === 4) ? 'bid' : 'tender'
          // 用“系统+终端”的 scope 写入 token
          setScopedToken(legacy, { meta: { system: systemKey, terminal: terminalKey } })
          token = legacy
          console.log('Scoped Token (patched):', token);
        }
      }
    }

    if (!token) {
      const loginPage = to.meta && to.meta.loginPage ? to.meta.loginPage : '/login'
      next({ path: loginPage, replace: true })
      return
    }
  }

  const tenderMode = to.query.tenderMode;
  if (to.meta.requiresAuth && !sessionStorage.getItem('isAuthorized_'+to.query.tenderDocumentId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/protected') {
      next({
        path: '/protected',
        query: {
          tenderDocumentId: to.query.tenderDocumentId,
          tenderDocumentTitle: to.query.tenderDocumentTitle,
          contactPerson: to.query.contactPerson,
          contactPhone: to.query.contactPhone,
        }
      })
    } else {
      next();
    }
  } else if (to.meta.auctionItemRequiresAuth && !sessionStorage.getItem('isAuthorized_auctionItem_'+to.query.auctionItemId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/auctionItem/protected') {
      next({
        path: '/auctionItem/protected',
        query: {
          auctionItemId: to.query.auctionItemId,
          auctionItemTitle: to.query.auctionItemTitle,
        }
      })
    } else {
      next();
    }
  } else if (to.meta.logisticsRequiresAuth && !sessionStorage.getItem('isAuthorized_logistics_'+to.query.tenderDocumentId) 
    && (tenderMode === '0' || typeof(tenderMode) === "undefined")) {
    // 如果 tenderMode 为 0，则跳转至 /detail 路由
    if (to.path !== '/logisticsTender/protected') {
      next({
        path: '/logisticsTender/protected',
        query: {
          tenderDocumentId: to.query.tenderDocumentId,
          tenderDocumentTitle: to.query.tenderDocumentTitle,
        }
      })
    } else {
      next();
    }
  } else {
    console.log('Navigating to:', to.path);
    console.log('user_type:', getCache('user_type'));
    console.log('system_type:', getCache('system_type'));
    // 如果是系统类型为1林业竞拍
    if(getCache('system_type') === 1){
      // 如果是林业竞拍的投标方，那么就只能进入投标相关的页面，把各系统的登录页、注册页都放开，/tendering/home和/tendering/detail主干分支上需要处理，主干分支会有账号登录
      if(getCache('user_type') === 3 || getCache('user_type') === 4){
        if(to.path.includes("/auctionItem/tendering") || to.path === '/auctionItem/protected' || to.path === '/noPermission' || to.path === '/filePreview'
        || to.path === '/auctionItem/sysLogin' || to.path === '/auctionItem/login' 
        || to.path === '/logisticsTender/sysLogin' || to.path === '/logisticsTender/login'
        || to.path === '/logisticsTender/register' || to.path === '/auctionItem/register'
        || to.path === '/user/register' || to.path === '/user/login' || to.path === '/protected' || to.path === '/tendering/home' || to.path === '/tendering/detail'){
          next();
        } else{
          next({path: '/noPermission'});
        }
      } else {
        next();
      }
    } else if(getCache('system_type') === 2){
      // 如果是物流的投标方，那么就只能进入投标相关的页面，把各系统的登录页、注册页都放开
      if(getCache('user_type') === 3 || getCache('user_type') === 4){
        if(to.path.includes("/logisticsTender/tendering") || to.path === '/logisticsTender/protected' || to.path === '/noPermission' || to.path === '/filePreview'
        || to.path === '/logisticsTender/sysLogin' || to.path === '/logisticsTender/login'
        || to.path === '/auctionItem/sysLogin' || to.path === '/auctionItem/login'
        || to.path === '/logisticsTender/register' || to.path === '/auctionItem/register' 
        || to.path === '/user/register' || to.path === '/user/login' || to.path === '/protected' || to.path === '/tendering/home' || to.path === '/tendering/detail'){
          next();
        } else{
          next({path: '/noPermission'});
        }
      } else {
        next();
      }
    } else {
      next();
    }
    
  }
})

  

  
// router.beforeEach((to, from, next) => {
//   var tokenStr = null
//   if (to.meta.requiresAuth && !isAuthorized()) {
//     if(to.query.tenderMode === '0' || typeof(tenderMode) === "undefined"){
//       if (to.path !== '/protected') {
//         next({
//           path: '/protected',
//           query: {
//             tenderDocumentId: to.query.tenderDocumentId,
//           }
//         })
//         tokenStr = sessionStorage.getItem('token')